export default {
  grouping: {
    groupBy: "Raggruppa per",
    assetClass: "Classe di attivi",
    currency: "Valuta",
    sector: "Settore",
    region: "Regione",
    strategy: "Strategia",
    uncategorized: "Non categorizzato",
  },
  pages: {
    avg: "Media",
    max: "Max",
    min: "Min",
    footer: {
      page: "Pagina",
    },
    strategyReport: {
      title: "Proposta di investimento",
      strategyName: (ctx) =>
        `Nome della strategia: ${ctx.named("portfolioName")} (${ctx.named("currency")})`,
      forRecipient: (ctx) => `Per: ${ctx.named("recipient")}`,
      preparedBy: (ctx) => `Preparato da: ${ctx.named("author")}`,
      period: (ctx) => `Periodo: ${ctx.named("periodStart")} - ${ctx.named("periodEnd")}`,
    },
    tableOfContents: {
      title: "Indice",
    },
    portfolioComposition: {
      title: "Composizione del portafoglio",
      currencyAlloc: "Allocazione per valuta",
      assetClassAlloc: "Allocazione per classe di attivi",
      sectorAlloc: "Allocazione per settore",
      regionAlloc: "Allocazione per regione",
      composition: "Composizione",
    },
    performanceAnalysis: {
      title: "Analisi della performance",
      investGrowth: "Crescita dell'investimento",
      keyPerfStats: {
        title: "Statistiche chiave di performance",
      },
      histYearyRets: "Rendimenti annuali storici",
      histMonthRets: "Rendimenti mensili storici",
    },
    riskAnalysis: {
      title: "Analisi del rischio",
      drawdownAnalysis: "Analisi dei drawdown",
      drawdownTable: {
        title: "Tabella dei drawdown",
        drawdownRank: "Classifica drawdown",
        startDate: "Data di inizio",
        troughDate: "Data minima",
        recoveryDate: "Data di recupero",
      },
    },
    portfolioHoldings: {
      title: "Posizioni del portafoglio",
      topHoldings: {
        title: "Principali posizioni",
        name: "Nome",
        isin: "ISIN",
        currency: "Valuta",
        assetClass: "Classe di attivi",
        sector: "Settore",
        region: "Regione",
        weight: "Peso",
      },
    },
  },
  productPicker: {
    add: "Aggiungi",
    searchPlaceholder: "Cerca un prodotto...",
  },
  report: {
    backToInputs: "Torna agli input",
    downloadReport: "Scarica il report",
    taskFailed: (ctx) => `L'attività ${ctx.named("taskName")} è fallita: ${ctx.named("reason")}`,
  },
  reportInputs: {
    generateReport: "Genera report",
    fields: {
      general: {
        title: "Generale",
        portfolioName: "Nome del portafoglio",
        currency: "Valuta",
        author: "Autore",
        recipient: "Destinatario",
        totalCapital: (ctx) => `Capitale totale (${ctx.named("currency")})`,
        totalCapitalTooltip:
          "Serve a mostrare l'importo investito di ciascuna posizione nella tabella delle principali partecipazioni, assumendo questo capitale alla fine del periodo. Lasciare vuoto per nascondere quella colonna.",
      },
      composition: {
        title: "Composizione",
        product: "Prodotto",
        availableFrom: "Disponibile dal",
        availableUntil: "Disponibile fino al",
        period: "Periodo",
        fullPeriod: "Periodo intero",
        weight: "Peso (%)",
        addProduct: "Aggiungi prodotto",
        total: "Totale",
        selectOneProduct:
          "Selezionare almeno un prodotto nella composizione per poter selezionare un periodo.",
        noOverlappingPricePeriod:
          "I prodotti selezionati non hanno uno storico dei prezzi in comune, quindi non è possibile selezionare un periodo di report.",
      },
      miscellaneous: {
        title: "Varie",
        numMonthlyReturns: "Numero di anni per i rendimenti mensili storici",
        numTopHoldings: "Numero di posizioni per le principali partecipazioni",
        numTopHoldingsTooltip: "Lasciare vuoto per ottenere tutte le posizioni.",
      },
    },
  },
  weightOptimization: {
    portfoliosWeightsAllocation: "Allocazione dei pesi dei portafogli",
    addProduct: "Aggiungi prodotto",
    addPortfolio: "Aggiungi portafoglio",
    total: "Totale",
    chartsAndTables: {
      buttonText: "Genera grafici e tabelle",
      dataLoadError:
        "Si è verificato un errore durante il caricamento dei dati. Riprovare o contattare Alquant AG se il problema persiste.",
      drawdowns: "Drawdown",
      performance: "Performance",
      period: "Periodo",
      periodSelectionCondition:
        "Assicurarsi che ogni componente con un peso diverso da zero in qualsiasi portafoglio abbia un prodotto selezionato.",
      returnToRiskSpace: "Torna allo spazio rischio-rendimento",
      selectedPortfolios: "Portafogli selezionati",
      statistics: "Statistiche",
      year: "Anno",
      yearlyReturns: "Rendimenti annuali",
    },
    actionTooltip: {
      restoreDefaultPortfolio: (ctx) =>
        `Ripristinare l'allocazione predefinita per «${ctx.named("portfolioName")}».`,
      optimizeWeight: (ctx) =>
        `Ottimizzare i pesi per «${ctx.named("portfolioName")}» in base a vincoli e obiettivi.`,
      cantOptimizeWeight:
        "L'ottimizzazione richiede un prodotto selezionato per ogni riga, oltre ad almeno una posizione.",
      usePortfolioToGenerateReport: (ctx) =>
        `Generare un report utilizzando il portafoglio «${ctx.named("portfolioName")}».`,
      cantGenerateReport:
        "La generazione del report richiede un prodotto selezionato per ogni riga e un'allocazione totale esattamente del 100 %.",
      removePortfolio: (ctx) => `Rimuovere «${ctx.named("portfolioName")}» dal confronto.`,
      cantRemovePortfolio: "Almeno un portafoglio deve restare nel confronto.",
    },
    optimizationDialog: {
      title: "Impostazioni di ottimizzazione",
      objective: "Obiettivo",
      period: "Periodo di ottimizzazione",
      bounds: "Limiti di allocazione",
      addBound: "Aggiungi limite",
      singlePosition: "Singola posizione",
      type: "Tipo",
      target: "Obiettivo",
      min: "Min",
      max: "Max",
      buttonText: "Esegui ottimizzazione",
      optimization: {
        maxRetWithTargetMaxVol: {
          name: "Massimizzare il rendimento (volatilità annua obiettivo)",
          targetTitle: "Volatilità annua massima",
        },
        maxRetWithTargetPainIndex: {
          name: "Massimizzare il rendimento (pain index obiettivo)",
          targetTitle: "Pain index massimo",
        },
        maxRetWithTargetMaxDrawdown: {
          name: "Massimizzare il rendimento (drawdown obiettivo)",
          targetTitle: "Drawdown massimo",
        },
        minVolWithTargetMinRet: {
          name: "Minimizzare la volatilità (rendimento annuo obiettivo)",
          targetTitle: "Rendimento annuo minimo",
        },
        minDrawdownWithTargetMinRet: {
          name: "Minimizzare il drawdown massimo (rendimento annuo obiettivo)",
          targetTitle: "Rendimento annuo minimo",
        },
        maxSharpe: {
          name: "Massimizzare il rapporto di Sharpe",
        },
        maxSortino: {
          name: "Massimizzare il rapporto di Sortino",
        },
      },
    },
    failedOptimizationDialog: {
      title: "Ottimizzazione fallita",
      text: "Nessuna soluzione trovata. I vincoli (valori obiettivo e limiti di allocazione) potrebbero essere troppo restrittivi.",
    },
  },
};
